var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationConversation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 70a1 1 0 01-.707-.293L14.586 60H13c-2.757 0-5-2.243-5-5V23c0-2.757 2.243-5 5-5h17v2H13c-1.654 0-3 1.346-3 3v32c0 1.654 1.346 3 3 3h2a1 1 0 01.707.293L24 66.586V59a1 1 0 011-1h18c1.654 0 3-1.346 3-3V45a1 1 0 011-1h4.912l-5.831-13.606A.989.989 0 0146 30v-7c0-1.654-1.346-3-3-3h-7v-2h7c2.757 0 5 2.243 5 5v6.795l5.919 13.811A.989.989 0 0154 44v1a1 1 0 01-1 1h-5v9c0 2.757-2.243 5-5 5H26v9a1.002 1.002 0 01-1 1",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 62a1.002 1.002 0 01-1-1v-9h-4v-2h5a1 1 0 011 1v7.586l8.293-8.293A.997.997 0 0165 50h2c1.654 0 3-1.346 3-3V15c0-1.654-1.346-3-3-3H37c-1.654 0-3 1.346-3 3v9c0 .135-.027.27-.081.394L28.088 38H33a1 1 0 011 1v8c0 1.654 1.346 3 3 3h7v2h-7c-2.757 0-5-2.243-5-5v-7h-5a1 1 0 01-1-1v-1c0-.135.027-.27.081-.394L32 23.795V15c0-2.757 2.243-5 5-5h30c2.757 0 5 2.243 5 5v32c0 2.757-2.243 5-5 5h-1.586l-9.707 9.707A1 1 0 0155 62",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M52 20h14v-2H52zM52 24h14v-2H52zM52 28h10v-2H52zM14 26h12v-2H14zM14 30h12v-2H14zM14 34h8v-2h-8z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationConversation;